import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-67837c0f"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "historic-skeleton" };
const _hoisted_2 = { class: "historic-skeleton__body" };
const _hoisted_3 = { class: "historic-skeleton__table-wrapper" };
const _hoisted_4 = { class: "historic-skeleton__table-header" };
const _hoisted_5 = { class: "historic-skeleton__table-body" };
import SkeletonLoader from '@/components/_atoms/SkeletonLoader.vue';
import ListPaginationLoader from '@/components/_atoms/ListPaginationSkeleton.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AudienceHistoricSkeleton',
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(SkeletonLoader, {
                    height: "20px",
                    width: "220px",
                    class: "skeleton historic-skeleton__title"
                }),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createVNode(SkeletonLoader, {
                                height: "20px",
                                width: "40px",
                                class: "skeleton text-center"
                            }),
                            _createVNode(SkeletonLoader, {
                                height: "20px",
                                width: "70px",
                                class: "skeleton"
                            }),
                            _createVNode(SkeletonLoader, {
                                height: "20px",
                                width: "80px",
                                class: "skeleton"
                            }),
                            _createVNode(SkeletonLoader, {
                                height: "20px",
                                width: "60px",
                                class: "skeleton"
                            }),
                            _createVNode(SkeletonLoader, {
                                height: "20px",
                                width: "120px",
                                class: "skeleton"
                            }),
                            _createVNode(SkeletonLoader, {
                                height: "20px",
                                width: "110px",
                                class: "skeleton"
                            })
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (row) => {
                                return _createElementVNode("div", {
                                    key: row,
                                    class: "historic-skeleton__table-row"
                                }, [
                                    _createVNode(SkeletonLoader, {
                                        height: "20px",
                                        width: "80px",
                                        class: "skeleton"
                                    }),
                                    _createVNode(SkeletonLoader, {
                                        height: "20px",
                                        width: "50px",
                                        class: "skeleton"
                                    }),
                                    _createVNode(SkeletonLoader, {
                                        height: "20px",
                                        width: "160px",
                                        class: "skeleton"
                                    }),
                                    _createVNode(SkeletonLoader, {
                                        height: "20px",
                                        width: "50px",
                                        class: "skeleton"
                                    }),
                                    _createVNode(SkeletonLoader, {
                                        height: "20px",
                                        width: "170px",
                                        class: "skeleton"
                                    }),
                                    _createVNode(SkeletonLoader, {
                                        height: "20px",
                                        width: "50px",
                                        class: "skeleton"
                                    })
                                ]);
                            }), 64))
                        ])
                    ])
                ]),
                _createVNode(ListPaginationLoader, { class: "historic-skeleton__pagination" })
            ]));
        };
    }
});
